import { useCurrentUserRegions } from "../../AppWrapper2/hooks/useCurrentUserRegions.js";
import { useRegionContext } from "../../Regions/contexts/RegionContext.js";
import { useLocationsNearbyCurrentUser } from "../../Locations/hooks/useLocationsNearbyCurrentUser.js";
import { FormikSelectLocationAndSubLocation } from "../../Locations/shared/FormikSelectLocationAndSubLocation.js";
import { useMemo } from "react";
import { Button, Icon } from "@therms/atalaya";
import { IoMdAdd } from "react-icons/io";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdRefresh } from "react-icons/md";
import { useFormikContext } from "formik";
//#region src/modules/Events/components/EventSelectLocation.tsx
function EventSelectLocation() {
	const { currentRegion } = useCurrentUserRegions();
	const form = useFormikContext();
	const regionCtx = useRegionContext();
	const { data, loading } = useLocationsNearbyCurrentUser({ maxDistance: 5e3 }, { fire: !form.values.id });
	const addNearbyLocation = useMemo(() => {
		if (data?.locations?.length) return /* @__PURE__ */ jsxs("div", {
			className: "gap-sm inline-flex flex-wrap items-center",
			children: [
				loading && /* @__PURE__ */ jsx(Icon, {
					color: "neutral",
					Icon: MdRefresh,
					size: "sm",
					spin: true
				}),
				/* @__PURE__ */ jsx("span", {
					className: "text-neutral italic",
					children: "Nearby"
				}),
				data.locations.slice(0, 5).map((location) => {
					const disabled = form.values?.locationId === location.id;
					return /* @__PURE__ */ jsxs(Button, {
						className: "space-x-xxs",
						disabled,
						onClick: () => form.setFieldValue("locationId", location.id),
						subtle: true,
						children: [
							!disabled && /* @__PURE__ */ jsx(Icon, {
								color: "main",
								Icon: IoMdAdd,
								size: "sm"
							}),
							" ",
							/* @__PURE__ */ jsx("span", { children: location.name })
						]
					}, location.id);
				})
			]
		});
		if (data && !data?.locations?.length) return /* @__PURE__ */ jsx("span", {
			className: "text-neutral italic",
			children: "No nearby Locations"
		});
		return loading ? /* @__PURE__ */ jsxs("span", {
			className: "text-neutral italic",
			children: [/* @__PURE__ */ jsx(Icon, {
				color: "neutral",
				Icon: MdRefresh,
				size: "sm",
				spin: true
			}), " Searching nearby Locations..."]
		}) : null;
	}, [
		data,
		form?.values?.locationId,
		loading
	]);
	const createAddressRegionId = regionCtx ? regionCtx.regionId : currentRegion?.id;
	const selectProps = {
		isClearable: true,
		label: "Location",
		name: "locationId",
		placeholder: "Location",
		subLocationName: "subLocationId",
		subText: addNearbyLocation
	};
	if (!createAddressRegionId) return /* @__PURE__ */ jsx(FormikSelectLocationAndSubLocation, { ...selectProps });
	return /* @__PURE__ */ jsx(FormikSelectLocationAndSubLocation, {
		allowAddresses: true,
		createAddressRegionId,
		...selectProps
	});
}
//#endregion
export { EventSelectLocation };

//# sourceMappingURL=EventSelectLocation.js.map